var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChillblastLogoSymbolWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 169.89 169.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M89.79.28L23.63,0v23.63H0v61.31c0,46.75,37.91,84.94,84.94,84.94s84.94-37.91,84.94-84.94C169.6,39.62,134.26,2.85,89.79.28ZM115.29,98.99h22.99c-6.4,24.11-28.38,40.9-53.63,40.9-30.58,0-55.45-24.63-55.45-54.89s24.88-55.45,55.45-55.45c25.19,0,47.09,16.78,53.55,40.9h-22.92c-5.45-12.42-17.29-20.36-30.62-20.36-18.56,0-33.66,15.6-33.66,34.77s15.1,34.5,33.66,34.5c13.28,0,25.15-7.95,30.63-20.36Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChillblastLogoSymbolWhite);
export default __webpack_public_path__ + "static/media/chillblast-logo-symbol-white.76087dc0acc214c830c7b7f50f3cb367.svg";
export { ForwardRef as ReactComponent };